<panel width="600">
	<h1>{{ 'microsoft365.attach-to-plan.header' | translate }}</h1>
	@if (selectedSubscription && availableProductPlans.length == 0) {
		<list-view [selectable]="false">
			<list-item warning statusIcon="exclamation-triangle">{{ 'microsoft365.no-available-plans' | translate }}</list-item>
		</list-view>
	}
	<section>
		<custom-select [(value)]="selectedProductPlan"
					   (valueChange)="productPlanSelected()"
					   [label]="'microsoft365.select-plan-to-attach' | translate"
					   [selectList]="availableProductPlans"
					   [placeholder]="'microsoft365.select-plan-to-attach-placeholder' | translate"
					   [allowAutoFocus]="false"
					   [required]="true" />
	</section>
	@if (selectedProductPlan && selectedSubscription) {
	@if (mismatchInEndDates) {
	<section one-column>
		<p>{{ 'microsoft365.attach-to-plan.auto-renewal-date-mismatch' | translate:{ planEndDate: selectedProductPlan.autoRenewalDate | customDate: 'shortDate', subscriptionEndDate: subscriptionEndDate | customDate: 'shortDate' } }}</p>
		<custom-select [(value)]="newEndDate"
					   [label]="'microsoft365.select-new-end-date' | translate"
					   [selectList]="newEndDateList"
					   [placeholder]="'microsoft365.select-new-end-date-placeholder' | translate"
					   [allowAutoFocus]="false"
					   [required]="true" />
	</section>
	}
	<section one-column>
		<p>{{ 'microsoft365.attach-to-plan.confirmation-text' | translate:{ oldPlanName: (selectedProductPlan | productName), newPlanName: newProductPlanName, subscriptionName: selectedSubscription.name, subscriptionId: selectedSubscription.subscriptionId } }}</p>
	</section>
	}
	<section>
		<button ghost (click)="cancel()" [ignoreValidation]="true">{{ 'general.cancel' | translate }}</button>
		<button confirm [active]="canSave()" (click)="saveAndAttachPlan()">{{ 'microsoft365.attach-to-plan.save-and-attach-plan' | translate }}</button>
	</section>
</panel>
